import { AlphaJCircleIcon } from './AlphaJCircleIcon';

/**
 * author: Contributors
 * id 90C7D800-47CA-4E5E-860D-8AAB0F6C51DC
 * name alpha-j-circle
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-j-circle.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphabetJCircleIcon = AlphaJCircleIcon;
export default AlphabetJCircleIcon